import { useMemo, useState } from 'react';
import { categories, works, type WorkCategory } from '@/mocks/animeWorks';
import WorkCard from './WorkCard';

type Filter = '全部' | WorkCategory;

const filters: Filter[] = ['全部', ...categories];

export default function Featured() {
  const [active, setActive] = useState<Filter>('全部');

  const list = useMemo(() => {
    if (active === '全部') return works;
    return works.filter((w) => w.category === active);
  }, [active]);

  return (
    <section id="featured" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-sm font-semibold text-accent-800">
              <i className="ri-fire-fill" />
              人气精选
            </span>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              热门恋爱后宫推荐
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
              按剧情类型快速筛选，找到当下最值得一读的羞羞动漫漫画恋爱后宫作品。
            </p>
          </div>
        </div>

        <div className="mb-8 inline-flex flex-wrap gap-2 rounded-full bg-background-200/70 p-1">
          {filters.map((f) => (
            <button
              key={f}
              type="button"
              onClick={() => setActive(f)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                active === f
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-700 hover:bg-background-300/60'
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((work) => (
            <WorkCard key={work.id} work={work} />
          ))}
        </div>
      </div>
    </section>
  );
}